import { observable } from 'mobx';
import { getDocuments } from '../hooks/local_db/functions';
import { ICompany } from '../interface/Company';
import authService from '../services/AuthServices';
import { validateAndGetObject } from './utils';
import { IImagesBackendEnum } from '../../modules/commons/components/imageCropper/types';
import appStore from '../stores/AppStore';

/**
 * This function allow use company's info anywhere without set useCompany returned value to store manually
 *
 * @return company:Obserbable<ICompany>  Obserbable object with the info of logued company
 * @return refreshCompany:Function  Method that force company's data update
 *
 * * If you need force update company's info you can use:
 *
 *  useEffect(()=>autorun(refreshCompany),[]);
 *
 *  * Allso works on @computed methods on store
 *
 *  @computed
 *  get getCompanyName(): string {
 *     return company.name;
 *  }
 * */
export const { companyInfo, refreshCompany } = (() => {
  const company = observable({} as ICompany);
  function setCompany(value: ICompany) {
    Object.entries(value).forEach(([key, value]) => {
      (company as any)[key] = value;
    });
  }
  function refreshCompany(callBack?: (company: any) => void, onError?: () => void, noCache?: boolean) {
    try {
      getDocuments(
        'system/companyInfo',
        'Company',
        (newCompany: ICompany) => {
          setCompany(newCompany);
          callBack?.(newCompany);
          appStore?.handleUpdateCompanyLogoToDisplay?.(newCompany?.documentList || []);
        },
        noCache
      );
    } catch (error) {
      onError?.();
    }
  }

  refreshCompany();
  return {
    refreshCompany,
    companyInfo: company
  };
})();

export const getUrlLogo = (documentList: any[], type: IImagesBackendEnum) => {
  const logo = documentList?.find((el: any) => el.sourceType === type);
  if (!logo) {
    return '';
  }
  return (
    `${process.env.REACT_APP_API_URL}document/download/${createUrlToDeleteOrDownload(
      logo.fileName,
      logo.sourceType
    )}` || ''
  );
};

export const createUrlToDeleteOrDownload = (fileName: string, sourceType: string) => {
  const user = authService.getUser();
  if (user) {
    const challenge: string = authService.createToken(user);
    const requester: string = validateAndGetObject(user, 'alias.requester');
    return `${challenge}/${requester}/${sourceType}/${fileName}/`;
  }
  return '';
};
